import {routes_auth} from "@/router/auth";
import {routes_exception} from "@/router/exception";
import common from "@/locales/ja/common";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";
import store from "@/state/store";

const isMobile = DeviceDetectionMixin.methods.detectMobileDevice();
const screenList = store.state.permissions.screen_constant

/**
 * meta info
 * authRequired 認証が必要な画面かどうか index.jsを参照
 * url この画面にアクセス可能かどうかのチェック index.jsを参照
 * roleAuthIgnore 画面の権限にかかわらずアクセスさせたいauthrization_typesのidを入れておくと許可される。-1を入れておくと全権限に対して許可する
 */

export default [
  ...routes_auth,
  {
    path: '/',
    name: 'home',
    meta: (route) => ({ authRequired: true, title: common.menu_items.top, url: screenList?.SCREEN_HOME }),
    component: () => import('../views/pages/dashboard/index')
  },
  {
    path: '/estimates',
    name: 'estimate',
    meta: (route) => ({ authRequired: true, title: common.menu_items.estimates_search, url: screenList?.SCREEN_ESTIMATE }),
    component: () => import('../views/pages/estimate/index.vue')
  },
  {
    path: '/projects',
    name: 'projects',
    meta: (route) => ({ authRequired: true, title: common.menu_items.projects, url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/index.vue')
  },
  {
    path: '/projects/:id/sales',
    name: 'projects.sales',
    meta: (route) => ({ authRequired: true, title: common.sub_pages[route.query.activeTabIndex || 0], url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/sale/index.vue')
  },
  {
    path: '/projects/:id/sales/waste/:waste_id',
    name: 'projects.sales.wastes.detail',
    meta: (route) => ({ authRequired: true, title: common.sub_pages[0].replace('一覧', '') + '詳細', url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/sale/waste/index.vue')
  },
  {
    path: '/waste/:daily_report_id/:id',
    name: 'projects.sales.wastes.detail.daily-report',
    meta: (route) => ({ authRequired: true, title: common.sub_pages[0].replace('一覧', '') + '詳細', url: screenList?.SCREEN_PROJECT , roleAuthIgnore: [-1] }),
    component: () => import('../views/pages/project/sale/waste/index.vue')
  },
  {
    path: '/projects/:id/sales/work/:work_id',
    name: 'projects.sales.works.detail',
    meta: (route) => ({ authRequired: true, title: common.sub_pages[1].replace('一覧', '') + '詳細', url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/sale/work/index.vue')
  },
  {
    path: '/projects/:id/sales/contract/:contract_id',
    name: 'projects.sales.contracts.detail',
    meta: (route) => ({ authRequired: true, title: common.pages.project.sale.contract.treatment, url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/sale/contract/index.vue')
  },
  {
    path: '/projects/:id/sales/transport/:contract_id',
    name: 'projects.sales.transport.detail',
    meta: (route) => ({ authRequired: true, title: common.pages.project.sale.contract.transport, url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/sale/transport/index.vue')
  },
  {
    path: '/projects/:id/sales/instruction/:work_order_id?',
    name: 'projects.sales.instructions.detail',
    meta: (route) => ({ authRequired: true, title: common.pages.project.work_instruction.title, url: screenList?.SCREEN_PROJECT, roleAuthIgnore: [-1] }),
    component: () => import('../views/pages/project/sale/instruction/index.vue')
  },
  {
    path: '/calendar-settings',
    name: 'calendar-settings',
    meta: (route) => ({ authRequired: true, title: 'カレンダ設定', url: screenList?.SCREEN_CALENDAR_SETTING }),
    component: () => import('../views/pages/calendar/index.vue')
  },
  {
    path: '/projects/:case_id/work-reservations',
    name: 'projects.work_reservations.index',
    meta: (route) => ({ authRequired: true, title: '作業予約', url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/work_reserves/index.vue')
  },
  {
    path: '/projects/:case_id/work-reservations/register',
    name: 'projects.work_reservations.register',
    meta: (route) => ({ authRequired: true, title: '作業予約', url: screenList?.SCREEN_PROJECT }),
    component: () => import('../views/pages/project/work_reserves/register.vue')
  },
  // schedule routes
  {
    // 1-1
    path: '/schedules',
    name: 'schedules',
    meta: (route) => ({ authRequired: true, title: 'スケジュール一覧（営業用）', url: screenList?.SCREEN_SCHEDULE }),
    component: () => import('../views/pages/project/schedule/list.vue')
  },
  {
    // 1-2, 1-3
    path: '/schedules/work-reservations/:work_reservation_id/sale',
    name: 'projects.work_reservations.schedule.detail_for_sale',
    meta: (route) => ({ authRequired: true, title: 'スケジュール詳細', url: screenList?.SCREEN_SCHEDULE }),
    component: () => import('../views/pages/project/schedule/detail.vue')
  },
  {
    // 2-2, 2-3-1, 2-3-2
    path: '/schedules/work-reservations/:work_reservation_id/',
    name: 'projects.work_reservations.schedule.detail',
    meta: (route) => ({ authRequired: true, title: 'スケジュール詳細', url: screenList?.SCREEN_SCHEDULE_CAR }),
    component: () => import('../views/pages/project/schedule/detail.vue')
  },
  {
    // 2-1
    path: '/schedules-car',
    name: 'schedule.car.list',
    meta: (route) => ({ authRequired: true, title: 'スケジュール一覧（配車用）', url: screenList?.SCREEN_SCHEDULE_CAR }),
    component: () => import('../views/pages/project/schedule/list-by-car-manager.vue')
  },
  {
    // 3-1
    path: '/schedules/register-by-work-order/select-waste-or-service',
    name: 'projects.schedules.register_by_work_order.select_waste_or_service',
    meta: (route) => ({ authRequired: true, title: "作業指示別廃棄物・サービス一覧", url: screenList?.SCREEN_SCHEDULE_CAR }),
    component: () => import('@/views/pages/wastes_or_services/register.vue')
  },
  {
    // 3-1
    path: '/schedules/register-by-work-order',
    name: 'projects.schedules.register_by_work_order',
    meta: (route) => ({ authRequired: true, title: 'スケジュール詳細', url: screenList?.SCREEN_SCHEDULE }),
    component: () => import('../views/pages/project/schedule/register_by_work_order.vue')
  },
  // ms5
  {
    // 1-2.作業日報入力
    path: '/daily-reports/:id/input',
    name: 'daily_reports.input',
    meta: (route) => ({ authRequired: true, title: '作業日報入力', url: screenList?.SCREEN_FACTORIES }),
    component: async () => {
      if (isMobile) {
        return import('../views/pages/daily_reports/sp/input.vue');
      } else {
        return import('../views/pages/daily_reports/input.vue');
      }
    }
  },
  //1-1-3
  {
    path: '/daily-reports-factory/:id',
    name: 'daily-reports-factory',
    meta: (route) => ({ authRequired: true, title: '作業日報一覧(工場)', url: screenList?.SCREEN_FACTORIES }),
    component: async () => {
      if (isMobile) {
        return import('../views/pages/daily_reports/sp/list_by_factory.vue');
      } else {
        return import('../views/pages/daily_reports/list_by_factory.vue');
      }
    }
  },
  //1-1-2
  {
    path: '/factories',
    name: 'factories',
    meta: (route) => ({ authRequired: true, title: '工場選択', url: screenList?.SCREEN_FACTORIES }),
    component: () => import('../views/pages/daily_reports/factories')
  },
  //1-1-1
  {
    path: '/daily-reports',
    name: 'daily-reports',
    meta: (route) => ({ authRequired: true, title: '作業日報一覧（運搬）', url: screenList?.SCREEN_FACTORIES }),
    component: async () => {
      if (isMobile) {
        return import('../views/pages/daily_reports/components/sp/list.vue');
      } else {
        return import('../views/pages/daily_reports/list.vue');
      }
    }
  },
  // ms5 2-1
  {
    path: '/daily-reports/search-approve',
    name: 'daily.reports.search.approve',
    meta: (route) => ({ authRequired: true, title: '作業日報承認検索', url: screenList?.SCREEN_DAILY_REPORT_SEARCH_APPROVE }),
    component: () => import('../views/pages/daily_reports/approve/search.vue')
  },
  // ms5 2-2
  {
    path: '/daily-reports/:id/approve',
    name: 'daily.reports.approve',
    meta: (route) => ({ authRequired: true, title: '作業日報承認', url: screenList?.SCREEN_DAILY_REPORT_SEARCH_APPROVE }),
    component: () => import('../views/pages/daily_reports/input.vue')
  },
  {
    // ms5 2-3.作業日報メンテナンス検索 Daily work report maintenance search
    path: '/daily-reports/search-maintenance',
    name: 'daily.reports.search.maintenance',
    meta: (route) => ({ authRequired: true, title: '作業日報メンテナンス検索', url: screenList?.SCREEN_DAILY_REPORT_SEARCH_MAINTENANCE }),
    component: () => import('../views/pages/daily_reports/maintenance/search.vue')
  },
  {
    // 2-4-1. Maintenance daily report 1
    path: '/daily-reports/:id/maintenance/approve',
    name: 'daily.reports.maintenance.approve',
    meta: (route) => ({ authRequired: true, title: '作業日報メンテナンス', url: screenList?.SCREEN_DAILY_REPORT_SEARCH_MAINTENANCE }),
    component: () => import('../views/pages/daily_reports/input.vue')
  },
  {
    // 2-4-2. Maintenance daily report 2
    path: '/daily-reports/:id/maintenance/add',
    name: 'daily.reports.maintenance.add',
    meta: (route) => ({ authRequired: true, title: '作業日報メンテナンス', url: screenList?.SCREEN_DAILY_REPORT_SEARCH_MAINTENANCE }),
    component: () => import('../views/pages/daily_reports/input.vue')
  },
  {
    // 3-1. マニフェスト検索 Manifests
    path: '/manifests',
    name: 'manifests',
    meta: (route) => ({ authRequired: true, title: 'マニフェスト検索', url: screenList?.SCREEN_MANIFEST }),
    component: () => import('../views/pages/daily_reports/manifests/search.vue')
  },
  {
    // 3-2.マニフェスト編集 Manifests Edit
    path: '/manifests/:id',
    name: 'manifests.edit',
    meta: (route) => ({ authRequired: true, title: 'マニフェスト編集', url: screenList?.SCREEN_MANIFEST }),
    component: () => import('../views/pages/daily_reports/manifests/edit.vue')
  },
  {
    // 3-2.マニフェスト編集 Manifests Edit by number
    path: '/manifests/number/:number',
    name: 'manifests.edit.number',
    meta: (route) => ({ authRequired: true, title: 'マニフェスト編集', url: screenList?.SCREEN_MANIFEST }),
    component: () => import('../views/pages/daily_reports/manifests/edit.vue')
  },
  {
    // 3-3.マニフェスト紐付 Manifests Attach
    path: '/manifests/attach/:id',
    name: 'manifests.attach',
    meta: (route) => ({ authRequired: true, title: 'マニフェスト紐付', url: screenList?.SCREEN_MANIFEST }),
    component: () => import('../views/pages/daily_reports/manifests/ManifestAttach.vue')
  },
  {
    // お知らせ Notifications
    path: '/notifications',
    name: 'notifications',
    meta: (route) => ({ authRequired: true, title: 'お知らせ', url: screenList?.SCREEN_NOTICATIONS }),
    component: () => import('../views/pages/notifications/search.vue')
  },
  {
    // お問合せ Inquiries
    path: '/inquiries',
    name: 'inquiries.input',
    meta: (route) => ({ authRequired: true, title: 'お問合せ', url: screenList?.SCREEN_INQUIRIES }),
    component: () => import('../views/pages/inquiries/input.vue')
  },
  {
    // システム設定 System code setting
    path: '/system-setting',
    name: 'system-setting',
    meta: (route) => ({ authRequired: true, title: 'システム設定', url: screenList?.SCREEN_SYSTEM_SETTING }),
    component: () => import('../views/pages/system_setting/index.vue')
  },
  //only write new route above this constant
  ...routes_exception
]
